import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "SectionTitle" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "Dots" }, null, -1)
const _hoisted_4 = { class: "PageNumber" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PDFPage = _resolveComponent("PDFPage")!

  return (_openBlock(), _createBlock(_component_PDFPage, {
    class: "PDFTableOfContents",
    context: _ctx.context
  }, {
    sectionTitle: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.mixWB('TABLE_OF_CONTENTS')), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("ol", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section) => {
          return (_openBlock(), _createElementBlock("li", {
            key: section.title
          }, [
            _createElementVNode("a", {
              href: '#' + section.encodedTitle
            }, [
              _createElementVNode("span", _hoisted_2, _toDisplayString(section.title), 1),
              _hoisted_3,
              _createElementVNode("span", _hoisted_4, _toDisplayString(section.pageNumber), 1)
            ], 8, _hoisted_1)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["context"]))
}